import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    bg: 'blackAlpha.500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: '2',
    pl: '3',
    pr: '2',
    mb: '1px',
    _hover: {
      textDecoration: 'none',
    },
    _last: {
      mb: 0,
    },
    fontFamily: 'accent',
    borderTop: '1px',
    borderBottom: '1px',
    borderColor: 'gamma.400',
  },
  textCompetitionName: {
    color: 'gamma.400',
    letterSpacing: '1px',
    fontWeight: 'bold',
    fontSize: 'xs',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
  },
  textMatchCount: {
    px: '1',
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'white',
  },
};
